import _ from 'lodash';

export const getTransactionHistoryData = (state) =>
  _.get(
    state,
    'PointOfSaleState.viewTransactionHistory.transactionHistoryData'
  );

export const getViewTransactionHistoryLoading = (state) =>
  _.get(state, 'PointOfSaleState.viewTransactionHistory.loading');

export const getTransactionHistoryDataError = (state) =>
  _.get(
    state,
    'PointOfSaleState.viewTransactionHistory.transactionHistoryDataError'
  );

export const getVoidSuccess = (state) =>
  _.get(state, 'PointOfSaleState.viewTransactionHistory.voidSuccess');

export const getTransactionHistoryPages = (state) =>
  _.get(
    state,
    'PointOfSaleState.viewTransactionHistory.transactionHistoryPages'
  );



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/history/state/selectors.js